<template>
  <div>
    <el-row :gutter="24" v-loading="load" class="box-card">
      <el-col :xs="24">

        <div class="comments comments_green" v-if="comment">
          <div class="comments-header">
            <div class="comments-header__title"><i class="el-icon-document-copy"></i> Комментарий специалиста во время
              приема:
            </div>
            <div class="comments-header__btn">
              <el-button round @click="copy(comment)">Копировать</el-button>
            </div>
          </div>
          <div class="comments__body">{{ comment }}</div>
        </div>

        <div class="comments" v-if="recommendation">
          <div class="comments-header">
            <div class="comments-header__title"><i class="el-icon-document-copy"></i> Ваш комментарий:</div>
            <div class="comments-header__btn">
              <el-button round @click="copy(recommendation)">Копировать</el-button>
            </div>
          </div>
          <div class="comments__body">{{ recommendation }}</div>
        </div>

        <el-tabs v-model="activeName">
          <el-tab-pane
              :label="item.title"
              :name="'item'+index"
              v-for="(item, index) in tabData.data"
              :key="index"
          >
            <el-row>
              <el-input
                  type="textarea"
                  v-model="item.text"
                  :rows="4"
                  :placeholder="item.title"
              ></el-input>
            </el-row>
          </el-tab-pane>
        </el-tabs>


      </el-col>
    </el-row>
    <el-row :gutter="5" class="content-box__btns">

      <el-button type="primary" @click="submitCard">Далее</el-button>
    </el-row>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "visit.conclusion",
  data() {
    return {
      activeName: "itemphys",
      load: !!1,
      tabData: {},
      nowDate: new Date(),
    };
  },
  computed: {
    ...mapGetters("visit", {recommendation: "recommendation"}),
    ...mapGetters("visit", {comment: "comment"}),

    visit() {
      return this.$route.params.visit;
    },
  },
  created() {
    if (this.visit) this.loadLogic();
    else this.$router.push({name: "visit.list"});
  },
  filters: {
    age(n) {
      let arr = ["год", "года", "лет"];
      return (
          n +
          " " +
          arr[
              n % 100 > 4 && n % 100 < 20
                  ? 2
                  : [2, 0, 1, 1, 1, 2][n % 10 < 5 ? n % 10 : 5]
              ]
      );
    },
  },
  mounted() {

    this.setStageVisit(2)


  },
  methods: {
    ...mapActions({
      setStageVisit: "visit/SET_STAGE",
      setVisit: "visit/SET_DATA",
    }),
    loadLogic() {
      this.load = true;
      this.$api.visit
          .getRecommendation(this.visit.id)
          .then((response) => {
            this.tabData = response.data;
            this.$root.$emit('getRecommendation');
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            this.load = false;
          });
    },
    submitCard() {
      this.load = true;
      this.$api.visit
          .postRecommendation(this.visit.id, this.tabData)
          .then(() => {
            this.$notify.success({
              title: "Успешно",
              message: "Данные сохранены",
            });
            this.closeVisit();
          })
          .catch((res) => {
            this.$notify.error({
              title: "Упс..",
              message: res.response.data.message,
            });
          })
          .finally(() => {
            this.load = !!0;
          });
    },
    closeVisit() {
      this.load = true;
      this.$api.visit
          .close(this.visit.id)
          .then(() => {
            this.$notify.success({
              title: "Визит закрыт",
            });

            this.setStageVisit(5)
            this.setVisit()

            this.$router.push({
              // name: "visit.state",
              name: "visit.list",
              params: {id: this.visit.id, visit: this.visit},
            });
          })
          .catch((res) => {
            this.$notify.error({
              title: "Упс..",
              message: res.response.data.message,
            });
          })
          .finally(() => {
            this.load = !!0;
          });
    },
    copy(t) {
      const el = document.createElement('textarea');
      el.value = t;
      document.body.appendChild(el);
      el.select();

      document.execCommand('copy');
      document.body.removeChild(el);

      this.$notify.success({
        title: "Скопировано",
        message: "Текст скопирован в буфер обмена!"
      })

    },
    goBack() {
      this.$router.push({
        name: "visit.device",
        params: {id: this.visit.id},
      });
    },
  },
};
</script>

<style scoped lang="scss">

.box-card {
  max-width: 560px;
  border: 0;
  box-shadow: none;
  padding: 10px;
  background: #fff;

  margin: 20px 0 !important;
  border-radius: 6px;

}

.content-box {
  &__subtitle {
    margin: 0 0 20px 0;

    font-weight: bold;
    font-size: 16px;
    line-height: 34px;
    color: #333;
  }

  &__btns {
    margin: 20px 0 0 0;
  }
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__title {
    display: inline-block;
    font-weight: bold;
    font-size: 30px;
    line-height: 38px;
    color: #333;
    margin: 0;
  }

  &__btn {
    font-size: 16px;
    line-height: 140%;
    color: #6c81a0;
  }
}

.comments {
  max-width: 560px;
  line-height: 1.8;
  font-size: 12px;
  padding: 18px 24px;
  background-color: #fafafa;
  border: 1px solid #eaeefb;
  margin-bottom: 25px;
  border-radius: 4px;

  &_green {
    background-color: #e7ffe5;
    border: 1px solid #cef8c5;
  }

  &-header {
    display: flex;
    justify-content: space-between;

    &__title {
      font-size: 14px;
      color: #5e6d82;
      line-height: 1.5em;
    }

    &__btn {

    }
  }


  &__body {
    margin-top: 10px;
    font-size: 12px;
    color: #222;
    line-height: 1.5em;

    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
